import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from "react";
import { Form, Input, Radio, Mentions, Button, Row, Col, Divider, Alert, Spin, Select, message } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { saveGroupAsync, getGroupsAsync, resetGoupSavingState } from "../../redux/boardSlice";
import MaterialDesignIcon from "../common/MaterialDesignIcon";
import "./AddBoardGroup.css";
const { Option } = Mentions;
const { REACT_APP_CONNECTION_INFO_BASE_URL } = process.env;
const AddBoardGroup = (props, ref) => {
  const [groupName, setGroupName] = useState("");
  const [groupType, setGoupType] = useState(null);
  const [radioVal, setRadioVal] = useState(1);
  const [sharedListShow, setSharedListShow] = useState(true);
  const [usersList, setUsersList] = useState([]);
  const [userIdList, setUserIdList] = useState([]);
  const [subGroupNames, setSubGroupNames] = useState([""]);
  const [selectedGroupDetails, setSelectedGroupDetails] = useState({});
  const [shareWithValue, setShareWithValue] = useState("");
  const [groupNameValidation, setGroupNameValidation] = useState({
    status: "",
    message: "",
  });
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [cursorPosition, setCursorPosition] = useState(null);

  const groupNameInputRef = useRef(null);

  const groupNameValidationRef = useRef(groupNameValidation);
  useEffect(() => {
    groupNameValidationRef.current = groupNameValidation;
  }, [groupNameValidation]);

  // Store initial values for proper reset in edit mode
  const [initialValues, setInitialValues] = useState({
    groupName: "",
    groupType: null,
    radioVal: 1,
    sharedListShow: true,
    usersList: [],
    userIdList: [],
    subGroupNames: [""],
    shareWithValue: "",
  });

  const [form] = Form.useForm();

  const dispatch = useDispatch();
  let history = useHistory();

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const resetToInitialState = () => {
    form.resetFields();
    form.setFields([{ name: "groupname", errors: [] }]);
    setGroupName("");
    setGoupType(null);
    setRadioVal(1);
    setSharedListShow(true);
    setUsersList([]);
    setUserIdList([]);
    setSubGroupNames([""]);
    setSelectedGroupDetails({});
    setShareWithValue("");
    setInitialValues({
      groupName: "",
      groupType: null,
      radioVal: 1,
      sharedListShow: true,
      usersList: [],
      userIdList: [],
      subGroupNames: [""],
      shareWithValue: "",
    });
    setGroupNameValidation({ status: "", message: "" });
    setFormSubmitted(false);
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      setDebounceTimer(null);
    }
  };

  // Reset to initial edit values (for edit mode)
  const resetToEditInitialState = () => {
    setGroupName(initialValues.groupName);
    setGoupType(initialValues.groupType);
    setRadioVal(initialValues.radioVal);
    setSharedListShow(initialValues.sharedListShow);
    setUsersList(initialValues.usersList);
    setUserIdList(initialValues.userIdList);
    setSubGroupNames(initialValues.subGroupNames);
    setShareWithValue(initialValues.shareWithValue);

    // Reset form to initial edit values
    form.setFieldsValue({
      groupname: initialValues.groupName,
      grouptype: initialValues.groupType,
    });
  };

  console.log("groupName", groupName, "groupType", groupType);

  useImperativeHandle(ref, () => ({
    resetToInitialState,
    resetToEditInitialState,
  }));
  useEffect(() => {
    if (groupNameValidation.status === "duplicate" || groupNameValidation.status === "available") {
      form.validateFields(["groupname"]);
    }
  }, [groupNameValidation]);

  useEffect(() => {
    if (groupNameInputRef.current && cursorPosition !== null) {
      groupNameInputRef.current.input.setSelectionRange(cursorPosition, cursorPosition);
      groupNameInputRef.current.focus();
    }
  }, [groupNameValidation]);

  // Effect to reset state when modal closes
  useEffect(() => {
    return () => {
      // Only reset completely when component unmounts
      if (!props.selectedGroup) {
        resetToInitialState();
      }
    };
  }, []);

  // Handle visibility changes
  useEffect(() => {
    if (props.visible === false) {
      // Don't auto-reset here, let parent handle it
    }
  }, [props.visible]);

  const boardSelector = useSelector((state) => state.boards);

  const onChangeRadio = (e) => {
    if (e.target.value === 1) {
      setRadioVal(1);
      setSharedListShow(true);
    } else if (e.target.value === 2) {
      setRadioVal(2);
      setSharedListShow(false);
    } else {
      setRadioVal(3);
      setSharedListShow(false);
    }
  };

  useEffect(() => {
    if (props.selectedGroup) {
      console.log("selecetedGroup", props.selectedGroup);
      const { title, groupType, shareWith, isGlobal, isPublic, children } = props.selectedGroup;
      const newRadioVal = isGlobal ? 3 : isPublic ? 2 : 1;
      const newSharedListShow = newRadioVal === 1;

      // Set current state
      setGroupName(title);
      setGoupType(groupType);
      setUserIdList(shareWith || []);
      setUsersList(shareWith || []);
      setRadioVal(newRadioVal);
      setSharedListShow(newSharedListShow);

      const subGroups = children && children.length > 0 ? children.map((c) => c.title) : [""];
      setSubGroupNames(subGroups);

      // Store these as initial values for reset
      setInitialValues({
        groupName: title,
        groupType: groupType,
        radioVal: newRadioVal,
        sharedListShow: newSharedListShow,
        usersList: shareWith || [],
        userIdList: shareWith || [],
        subGroupNames: subGroups,
        shareWithValue: "",
      });

      form.setFieldsValue({
        groupname: title,
        grouptype: groupType,
      });
    } else {
      // For new group, set initial values to empty
      setInitialValues({
        groupName: "",
        groupType: null,
        radioVal: 1,
        sharedListShow: true,
        usersList: [],
        userIdList: [],
        subGroupNames: [""],
        shareWithValue: "",
      });
    }
  }, [props.selectedGroup]);

  useEffect(() => {
    async function saveGroupSuccess() {
      if (boardSelector.groupSavingState === "success") {
        message.success("Group saved successfully!");
        setGroupName("");
        setUsersList([]);
        setUserIdList([]);
        setShareWithValue("");
        await dispatch(resetGoupSavingState());
        setTimeout(() => {
          props.handleCloseModal();
          resetToInitialState();
          history.push("/groups");
        }, 1000);
      } else if (boardSelector.groupSavingState === "error") {
        message.error("Group not saved!");
      }
    }
    saveGroupSuccess();
  }, [boardSelector]);

  const onSelectSharableUsers = (option) => {
    console.log("onSelectSharableUsers===>>", option);

    const selectedEmail = option.value;
    const selectedUserId = option.key.replace("board_user__", ""); // Extract UserID from key

    // Check if email already exists
    const emailAlreadyExists = usersList.includes(selectedEmail);

    if (!emailAlreadyExists) {
      setUsersList([...usersList, selectedEmail]);
      setUserIdList([...userIdList, selectedUserId]);
    }

    // ⭐ CLEAR THE INPUT FIELD IMMEDIATELY
    setShareWithValue("");

    // ⭐ CLEAR THE FORM FIELD VALUE
    form.setFieldsValue({ sharewith: "" });
  };

  const addGroups = () => {
    setSubGroupNames([...subGroupNames, ""]);
  };

  const setSubGroupName = (val, index) => {
    setSubGroupNames(subGroupNames.map((g, i) => (i === index ? val : g)));
  };

  const removeSubGoup = (id) => {
    setSubGroupNames(subGroupNames.filter((p, i) => id !== i));
  };

  const checkGroupNameDuplicate = async (name) => {
    if (!name || name.trim() === "" || name.length < 2) {
      setGroupNameValidation({ status: "", message: "" });
      return;
    }

    // Store cursor position BEFORE setting checking status
    if (groupNameInputRef.current && groupNameInputRef.current.input) {
      setCursorPosition(groupNameInputRef.current.input.selectionStart);
    }

    // Set checking status to show spinner
    setGroupNameValidation({ status: "checking", message: "Checking availability..." });
    // REACT_APP_CONNECTION_INFO_BASE_URL
    try {
      const response = await fetch(`${REACT_APP_CONNECTION_INFO_BASE_URL}/check-group-duplicate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({
          title: name.trim(),
          id: props.selectedGroup?.id || null,
        }),
      });

      const data = await response.json();

      // Update cursor position again before setting result
      if (groupNameInputRef.current && groupNameInputRef.current.input) {
        setCursorPosition(groupNameInputRef.current.input.selectionStart);
      }

      if (data.isDuplicate) {
        setGroupNameValidation({
          status: "duplicate",
          message: data.message || "A group with this name already exists",
        });
      } else {
        setGroupNameValidation({
          status: "available",
          message: "Group name is available",
        });
      }
    } catch (error) {
      setGroupNameValidation({
        status: "error",
        message: "Error checking group name availability",
      });
    }
  };

  const saveGroupInfo = async () => {
    setFormSubmitted(true);
    try {
      // Validate all form fields
      await form.validateFields();
      // Prepare shared with list
      let finalSharedWith = [...userIdList];

      // Add typed email if it's valid and not already in the list
      if (sharedListShow && shareWithValue && emailRegex.test(shareWithValue)) {
        // Check if the email is not already in usersList
        const emailAlreadyExists = usersList.includes(shareWithValue);
        if (!emailAlreadyExists) {
          finalSharedWith.push(shareWithValue);
        }
      }

      const values = await form.validateFields();

      let postData = {
        groupName: values.groupname,
        groupType: values.grouptype,
        isPublic: radioVal === 2,
        isGlobal: radioVal === 3,
        createdBySpecial: localStorage.getItem("IsSpecialUser") ? localStorage.getItem("IsSpecialUser") : false,
        sharedWith: sharedListShow ? finalSharedWith : [],
        subGroups: subGroupNames.filter((sg) => sg.trim() !== ""),
      };

      if (props.selectedGroup && props.selectedGroup.id) {
        postData.id = props.selectedGroup.id;
        postData.isEdit = true;
      }

      console.log("postDAta", postData);
      const response = await dispatch(saveGroupAsync(postData));
      if (response.payload.status === "SUCCESS") {
        setGroupNameValidation({ status: "", message: "" });
      }
      console.log("save group response", response);
    } catch (errorInfo) {
      console.log("Validation Failed:", errorInfo);
    }
  };

  // Custom validator for share with field
  const validateShareWith = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    if (!emailRegex.test(value)) {
      return Promise.reject(new Error("Please enter a valid email address"));
    }
    return Promise.resolve();
  };

  const handleShareWithChange = (value) => {
    setShareWithValue(value);
    // Trigger validation for share with field
    // form.validateFields(["sharewith"]);
    const fieldError = form.getFieldError("sharewith");

    if (fieldError.length > 0) {
      form.setFields([
        {
          name: "sharewith",
          errors: [],
        },
      ]);
    }
  };

  const handleChangeGroupType = (val) => {
    setGoupType(val);

    const fieldError = form.getFieldError("grouptype");

    if (fieldError.length > 0) {
      form.setFields([
        {
          name: "grouptype",
          errors: [],
        },
      ]);
    }
  };

  // Function to add typed email to the shared list
  const addTypedEmailToList = () => {
    if (shareWithValue && emailRegex.test(shareWithValue)) {
      const emailAlreadyExists = usersList.includes(shareWithValue);
      if (!emailAlreadyExists) {
        setUsersList([...usersList, shareWithValue]);
        setUserIdList([...userIdList, shareWithValue]); // For emails, use email as ID
      }
      setShareWithValue(""); // Clear the input
    }
  };

  // Handle Enter key press or blur to add email
  // const handleShareWithKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     addTypedEmailToList();
  //   }
  // };
  const handleShareWithKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // Read directly from the input value, not from state (state is one render behind)
      const currentValue = e.target?.value || shareWithValue;

      if (currentValue && !currentValue.startsWith("@") && emailRegex.test(currentValue)) {
        const emailAlreadyExists = usersList.includes(currentValue);
        if (!emailAlreadyExists) {
          setUsersList([...usersList, currentValue]);
          setUserIdList([...userIdList, currentValue]);
        }
        setShareWithValue("");
        form.setFieldsValue({ sharewith: "" });
      }
    }
  };

  // const handleShareWithBlur = () => {
  //   addTypedEmailToList();
  // };
  const handleShareWithBlur = () => {
    // Only add if it's a valid email and doesn't start with @
    if (shareWithValue && !shareWithValue.startsWith("@") && emailRegex.test(shareWithValue)) {
      const emailAlreadyExists = usersList.includes(shareWithValue);
      if (!emailAlreadyExists) {
        setUsersList([...usersList, shareWithValue]);
        setUserIdList([...userIdList, shareWithValue]);
      }
      setShareWithValue("");

      form.setFieldsValue({ sharewith: "" });
    }
  };

  console.log("props.users", props.users);
  return (
    <div>
      <Form name="customized_form_controls" initialValues={selectedGroupDetails} form={form}>
        <Row>
          <Col span={6}>
            Group Name <span style={{ color: "red" }}>*</span>
          </Col>
          <Col span={18}>
            <Form.Item
              name="groupname"
              validateTrigger={formSubmitted ? "onChange" : "onSubmit"}
              rules={[
                { required: true, message: "Please input group name!" },
                { min: 2, message: "Group name must be at least 2 characters long!" },
                {
                  validator: () => {
                    if (groupNameValidationRef.current.status === "duplicate") {
                      return Promise.reject(new Error(groupNameValidationRef.current.message));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                ref={groupNameInputRef}
                placeholder="Group Name"
                onChange={(e) => {
                  const newName = e.target.value;
                  const currentCursor = e.target.selectionStart;

                  setGroupName(newName);
                  setCursorPosition(currentCursor);

                  // clear duplicate status only (this is fine)
                  if (groupNameValidation.status !== "") {
                    setGroupNameValidation({ status: "", message: "" });
                  }

                  // debounce duplicate check (OK)
                  if (debounceTimer) clearTimeout(debounceTimer);

                  if (newName.trim().length >= 2) {
                    const newTimer = setTimeout(() => {
                      checkGroupNameDuplicate(newName);
                    }, 800);
                    setDebounceTimer(newTimer);
                  }
                }}
                onKeyDown={(e) => {
                  // Save cursor position on every keypress
                  setCursorPosition(e.target.selectionStart);
                }}
                onClick={(e) => {
                  // Save cursor position on click
                  setCursorPosition(e.target.selectionStart);
                }}
                disabled={props.isViewOnly}
                suffix={
                  groupNameValidation.status === "checking" ? (
                    <Spin size="small" />
                  ) : groupNameValidation.status === "available" ? (
                    <span style={{ color: "#52c41a", fontSize: "16px" }}>✓</span>
                  ) : groupNameValidation.status === "duplicate" ? (
                    <span style={{ color: "#ff4d4f", fontSize: "16px" }}>⚠</span>
                  ) : null
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={6}>
            Group Type <span style={{ color: "red" }}>*</span>
          </Col>
          <Col span={18}>
            <Form.Item name="grouptype" rules={[{ required: true, message: "Please select group type!" }]}>
              <Select
                style={{ width: "100%" }}
                placeholder="Select Group Type"
                value={groupType}
                onChange={(val) => handleChangeGroupType(val)}
                disabled={props.isViewOnly}
              >
                <Select.Option value="dashboard">Dashboard</Select.Option>
                <Select.Option value="report">Report</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div className="report-radiobtn-group-container">
              <Radio.Group value={radioVal} onChange={onChangeRadio} disabled={props.isViewOnly}>
                <Radio value={1}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <MaterialDesignIcon icon="fingerprint" />
                    <span>&nbsp;Private</span>
                  </div>
                </Radio>
                <Radio value={2}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <MaterialDesignIcon icon="groups" />
                    <span>&nbsp;Public</span>
                  </div>
                </Radio>
                {localStorage.getItem("IsSpecialUser") === "true" ? (
                  <Radio value={3}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <MaterialDesignIcon icon="public" />
                      <span>&nbsp;Global</span>
                    </div>
                  </Radio>
                ) : null}
              </Radio.Group>
            </div>
          </Col>
        </Row>

        {sharedListShow ? (
          <div>
            <Row>
              <Col span={6}>Share With</Col>
              {!props.isViewOnly ? (
                <Col span={18}>
                  <Form.Item name="sharewith" rules={[{ validator: validateShareWith }]} validateTrigger="onSubmit">
                    <Mentions
                      style={{ width: "100%" }}
                      id="users"
                      value={shareWithValue}
                      onChange={handleShareWithChange}
                      onSelect={onSelectSharableUsers}
                      onKeyDown={handleShareWithKeyPress}
                      onBlur={handleShareWithBlur}
                      disabled={props.isViewOnly}
                      placeholder="Enter email address or select from list (press Enter to add)"
                      prefix=""
                      notFoundContent={"No users found"}
                    >
                      {props.users && shareWithValue.length >= 1
                        ? props.users
                            .filter(
                              (user) =>
                                !usersList.includes(user?.UserDetails?.UserName) &&
                                user?.UserDetails?.UserName?.toLowerCase().includes(shareWithValue.toLowerCase()),
                            )
                            .map((user) => (
                              <Option
                                key={`board_user__${user.UserID}`}
                                data={user}
                                value={user?.UserDetails?.UserName}
                                onClick={() => this.onClickSharableUser(user)}
                                disabled={props.isViewOnly}
                              >
                                {user?.UserDetails?.UserName || "-"}
                              </Option>
                            ))
                        : null}
                    </Mentions>
                  </Form.Item>
                </Col>
              ) : usersList?.length > 0 ? (
                <Col span={18}>
                  <div style={{ marginTop: "2px" }}>
                    {usersList.map((email, index) => (
                      <span
                        key={index}
                        style={{
                          display: "inline-block",
                          background: "#f0f0f0",
                          padding: "2px 8px",
                          margin: "2px 2px 2px 0",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: `${props.isViewOnly ? "grey" : ""}`,
                        }}
                      >
                        {email}
                        {!props.isViewOnly && (
                          <CloseOutlined
                            style={{ marginLeft: "4px", cursor: "pointer" }}
                            onClick={() => {
                              setUsersList(usersList.filter((_, i) => i !== index));
                              setUserIdList(userIdList.filter((_, i) => i !== index));
                            }}
                          />
                        )}
                      </span>
                    ))}
                  </div>
                </Col>
              ) : (
                <span style={{ color: "gray" }}>no shared users</span>
              )}
            </Row>

            {/* Display added emails */}
            {!props.isViewOnly && usersList?.length > 0 && (
              <Row>
                <Col span={6}></Col>
                <Col span={18}>
                  <div style={{ marginTop: "-8px" }}>
                    {usersList?.map((email, index) => (
                      <span
                        key={index}
                        style={{
                          display: "inline-block",
                          background: "#f0f0f0",
                          padding: "2px 8px",
                          margin: "2px 2px 2px 0",
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: `${props.isViewOnly ? "grey" : ""}`,
                        }}
                      >
                        {email}
                        {!props.isViewOnly && (
                          <CloseOutlined
                            style={{ marginLeft: "4px", cursor: "pointer" }}
                            onClick={() => {
                              setUsersList(usersList.filter((_, i) => i !== index));
                              setUserIdList(userIdList.filter((_, i) => i !== index));
                            }}
                          />
                        )}
                      </span>
                    ))}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        ) : (
          <br />
        )}
        <br />
        {/* View Only - show subgroup names as read-only tags */}
        {props.isViewOnly && subGroupNames.filter((sg) => sg.trim() !== "").length > 0 && (
          <Row>
            <Col span={6}>Sub Groups</Col>
            <Col span={18}>
              <div style={{ marginTop: "2px" }}>
                {subGroupNames
                  .filter((sg) => sg.trim() !== "")
                  .map((sg, index) => (
                    <span
                      key={index}
                      style={{
                        display: "inline-block",
                        background: "#f0f0f0",
                        padding: "2px 8px",
                        margin: "2px 2px 2px 0",
                        borderRadius: "4px",
                        fontSize: "12px",
                        color: "grey",
                      }}
                    >
                      {sg}
                    </span>
                  ))}
              </div>
            </Col>
          </Row>
        )}

        {/* Edit mode - existing subgroups with inputs */}

        {subGroupNames.length > 0 &&
          !props.isViewOnly &&
          subGroupNames.map((sg, index) => {
            return (
              <Row key={"sg_" + index}>
                <Col span={6}>{index === 0 ? "Sub Groups" : ""}</Col>
                <Col span={18}>
                  <Input.Group compact>
                    <Input
                      style={{ width: "100%" }}
                      placeholder="Sub Group Name"
                      value={sg}
                      onChange={(e) => setSubGroupName(e.target.value, index)}
                      prefix={<div>{index + 1}.&nbsp;</div>}
                      suffix={<CloseOutlined onClick={() => removeSubGoup(index)} />}
                      disabled={props.isViewOnly}
                    />
                    {index === subGroupNames.length - 1 && !props.isViewOnly ? (
                      <Button
                        type="dashed"
                        onClick={() => addGroups()}
                        block
                        icon={<PlusOutlined />}
                        style={{ marginTop: "12px", alignItems: "center" }}
                        disabled={props.isViewOnly}
                      >
                        Add new
                      </Button>
                    ) : null}
                  </Input.Group>
                </Col>
              </Row>
            );
          })}

        {!props.isViewOnly ? (
          <>
            <Divider />
            <div style={{ display: "flex", flexDirection: "row-reverse", justifyContent: "space-between" }}>
              <Button
                type="primary"
                loading={boardSelector.groupSavingState === "pending"}
                style={{ width: "160px" }}
                onClick={saveGroupInfo}
              >
                Save Group
              </Button>
            </div>
          </>
        ) : null}
      </Form>
    </div>
  );
};

export default forwardRef(AddBoardGroup);
